enum TranslatedField {
  PREPARATION_CIT_FREEZE_TIME = 'preparation.citFreezeTime',
  PREPARATION_CIT_FORMALIN_TIME = 'preparation.citFormalinTime',
  METASTASIS_CIT_PREPARATION_FREEZE_TIME = 'metastasispreparations.metastasispreparation.citMetastasisFreezeTime',
  METASTASIS_CIT_PREPARATION_FORMALIN_TIME = 'metastasispreparations.metastasispreparation.citMetastasisFormalinTime',
}

export default TranslatedField
